import { Injectable } from '@angular/core';
import { AppCollection } from '../../app.config';
import { BaseCollectionService } from '../../core/jsonApi/BaseCollectionService';
import { SubjectJsonModel } from '../subject.json.model';

@Injectable({
  providedIn: 'root'
})
export class SubjectService extends BaseCollectionService<SubjectJsonModel, AppCollection> {
  protected ctor = SubjectJsonModel;
}
